<template>
  <form
    class="filter filter--search col-4"
    :class="{ 'mb-3': need_margin }"
    @submit.prevent="$emit('submit')"
  >
    <slot>
      <div class="row">
        <i-input
          :value="value"
          :clearable="true"
          :placeholder="$t('shared.component.filter.search')"
          suffix="ios-search"
          @keyup.enter.native="$emit('submit')"
          @on-clear="$emit('submit')"
          v-on="$listeners"
        />
      </div>
    </slot>
  </form>
</template>

<script>
  export default {
    props: {
      need_margin: {
        type: Boolean,
        default: true
      },

      value: {
        type: [String, Number],
        default: ''
      }
    }
  };
</script>
